import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Compra } from 'src/app/Models/compra/compra/compra';
import { Factura } from 'src/app/Models/factura/factura';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';

@Component({
  selector: 'app-print-compras',
  templateUrl: './print-compras.component.html',
  styleUrls: ['./print-compras.component.css']
})
export class PrintComprasComponent implements OnInit {

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: ActivatedRoute, private router:Router,private activatedRoute: ActivatedRoute) { }
  facturaId: string = '0';
  
  public compras: Compra[] = [];
  public totalventas:number = 0;
  public totalefectivo:number = 0;
  public totaltarjetas:number = 0;
  public rangofechas: RangoFechas= new RangoFechas();
  public today = new Date();
  public pagventas:any = 0;
  @ViewChild('pagina', null) public pagina: ElementRef;
  async ngOnInit() {
    this.title.setTitle('Informe de ventas');
    // this.activatedRoute.queryParams.subscribe(p => {
    //   console.log(p);
    //   if (p['data']) {
    //     const jsonObjeto = p['data'];
    //     this.rangofechas = JSON.parse(jsonObjeto);
    //   }
    // });
    this.rangofechas=this.data.getFechas();
    console.log(this.rangofechas);
    await this.GetData().then(()=>this.GetTotalVentas());
  }

  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }

  async GetData(){
    await this.data.PrintP(this.data.api.compra,this.rangofechas).then(r => {
      console.log(r);
      if (r.length<1) {
        console.error("Error");
      }else{
        this.compras = r;
      }
    }).catch(e => { console.log(e) });
  }

  GetTotalVentas(){
    this.compras.forEach(compra => {
      this.totalventas+= +compra.total
      //this.totalefectivo+= +compra.efectivo
      this.totaltarjetas+= +compra.tarjetachq
    });
  }

  public isbutton: Boolean = true;
  click:boolean = false;
  // async print() {
  //     const doc = new jsPDF({ orientation: 'p', unit: 'px', format: [820, this.pagina.nativeElement.offsetHeight + 80] });
  //     doc.setDisplayMode('');
  //     let html = this.pagina.nativeElement;
  //     await doc.html(this.pagina.nativeElement, { margin: 0, x: 0, y: 0 });
  //     var blobPDF =  new Blob([  ], { type : 'application/pdf'});
  //     var blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
  //     console.log(blobUrl);
  //     window.open(blobUrl);  // will open a new tab
  //     doc.autoPrint({variant: 'non-conform'});
  //     doc.save("Informe_ventas_detallado. pdf");
  // }

  async print() {
    const backButton = document.getElementById('backButton');
    if (backButton) {
      backButton.style.display = 'none';
    }

    // Remover el iframe anterior si existe
    const existingIframe = document.querySelector('iframe');
    if (existingIframe) {
      document.body.removeChild(existingIframe);
    }

    const element = this.pagina.nativeElement;
    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');

    // Definir las dimensiones del formato A4 en mm
    const pageWidth = 210; // Ancho de A4 en mm
    const pageHeight = 297; // Alto de A4 en mm
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width; // Proporción de altura basado en el ancho de A4

    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'a4'
    });

    let position = 0;
    let heightLeft = imgHeight;

    // Añadir la primera página
    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Añadir páginas adicionales si el contenido es más grande que una página
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    doc.autoPrint({ variant: 'non-conform' });

    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      if (iframe.contentWindow) {
        iframe.contentWindow.print();
      }
    };

    if (backButton) {
      backButton.style.display = 'block';
    }
  }
  mouseenter() {
    if(!this.click){
      this.isbutton = true;
    } else{
      this.isbutton = false;
    }
  }

  back(){
    this.router.navigateByUrl("/");
  }

}
